module.exports = __webpack_public_path__ + "img/frame (209).8e7cb87f.jpg";